import Helpers, { allBubbleNodes } from '../components/Viewer/Viewer-helpers'
import { getAllViewablesFromDoc } from './BubbleNodes'
import { handleDataToDownloadRvt } from './downloadJson'
import { getVersionByUrn } from './handleFileExtension'

export const getBasicInfo = (selectedSetting, selectedGuidViewCurrentModel) => {
  const urn = Helpers.getUrnViewer()
  const defaultView = getAllViewablesFromDoc(allBubbleNodes)[0][0].data.guid
  const defaultViewName = getAllViewablesFromDoc(allBubbleNodes)[0][0].data.name

  const version = getVersionByUrn(Helpers.getUrnViewer())
  // console.log('Urn:', decodeBase64(Helpers.getUrnViewer()))
  const currentViewName = selectedGuidViewCurrentModel
    ? selectedGuidViewCurrentModel[0]?.data?.name
    : defaultViewName
  const fileName = `${Helpers.getModelFileName()}_v${version}__${
    selectedSetting.nombre
  }__${currentViewName}`

  const currentGuidView = selectedGuidViewCurrentModel
    ? selectedGuidViewCurrentModel[0]?.data?.guid
    : defaultView

  return {
    urn,
    fileName,
    currentGuidView,
  }
}

export const handleDownloadData = async (
  selectedSetting,
  selectedGuidViewCurrentModel
) => {
  const extension = Helpers.getFileExtensionModel()

  const settingsWithKeys = selectedSetting.propiedades.map((property) => ({
    ...property,
    key: `${property.cat}/${property.name}`,
  }))
  let data = await Helpers.getData(
    selectedSetting.propiedades.map((property) => property.name)
  )

  data = data.map((element) => {
    const properties = element.properties.map((property) => {
      const setting = settingsWithKeys.find(
        (setting) =>
          setting.name === property.displayName &&
          setting.cat === property.displayCategory
      )
      return setting ? property : null
    })

    const propertiesNotNull = properties.filter((property) => property !== null)
    return { ...element, properties: propertiesNotNull }
  })

  const defaultView = getAllViewablesFromDoc(allBubbleNodes)[0][0].data.guid
  if (extension == 'rvt') {
    const handleData = handleDataToDownloadRvt(
      data,
      Helpers.getUrnViewer(),
      selectedGuidViewCurrentModel
        ? selectedGuidViewCurrentModel[0]?.data?.guid
        : defaultView
    )

    // Quitar espacios y sustituirlos por "_", lowercase y quitar acentos
    return handleData
  }
  if (extension == 'nwc' || extension == 'nwd') {
    // ! SUSTITUIR NEWARRAY POR ARRAY
    const filteredProperties = data.map((element) => {
      const newProperties = element.properties.filter((property) => {
        return selectedSetting.propiedades.some((elem) => {
          return (
            elem.name === property.displayName &&
            elem.cat === property.displayCategory
          )
        })
      })

      if (newProperties.length == 0) {
        // console.log('no hay propiedades', element.dbId)
        return
      }
      return { ...element, properties: newProperties }
    })
    const newData = handleDataToDownloadRvt(
      filteredProperties.filter((property) => property !== undefined),
      Helpers.getUrnViewer(),
      selectedGuidViewCurrentModel
        ? selectedGuidViewCurrentModel[0]?.data?.guid
        : defaultView
    )

    return newData
  }
}
